export const fmtINR = (n) => {
  const num = Number(n || 0);
  // en-IN "currency" style produces ₹ correctly on modern browsers; force
  // ₹ ourselves so the symbol is stable across locales/PDF exports.
  return "₹" + new Intl.NumberFormat("en-IN", { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(num);
};

// Compact ₹ formatter for chart axes. Zero → "₹0" (not "₹0.0L"), lakh /
// crore for large values, thousand-comma for the middle.
export const fmtINRCompact = (n) => {
  const num = Number(n || 0);
  if (num === 0) return "₹0";
  const abs = Math.abs(num);
  const sign = num < 0 ? "-" : "";
  if (abs >= 1e7) return `${sign}₹${(abs / 1e7).toFixed(1)}Cr`;
  if (abs >= 1e5) return `${sign}₹${(abs / 1e5).toFixed(1)}L`;
  if (abs >= 1e3) return `${sign}₹${(abs / 1e3).toFixed(1)}k`;
  return `${sign}₹${abs.toFixed(0)}`;
};

export const fmtNum = (n, opts = {}) => new Intl.NumberFormat("en-IN", { maximumFractionDigits: 2, ...opts }).format(Number(n || 0));

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return iso; }
};

export const today = () => new Date().toISOString().slice(0, 10);
